// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Ripple effect */\n.ripple {\n    background-position: center;\n    transition: background 0.8s;\n  }\n  .ripple:hover {\n    background: #47a7f5 radial-gradient(circle, transparent 1%, #47a7f5 1%) center/15000%;\n  }\n  .ripple:active {\n    background-color: #6eb9f7;\n    background-size: 100%;\n    transition: background 0s;\n  }\n\n ", ""]);
// Exports
module.exports = exports;
